import React from 'react';
import { Outlet } from 'react-router-dom';
import Navbar from './Navbar';
import CookieConsent from './CookieConsent';
import Footer from './Footer';

export default function Layout() {
  return (
    // Ustawiamy globalne tło i minimalną wysokość ekranu
    <div className="min-h-screen bg-gray-100">
      <Navbar />
      {/* Kontener centrujący treść, padding x-4 (na mobilkach) i p-6 (na desktopie) */}
      <main>
        <Outlet />
      </main>
      <Footer />
      <CookieConsent />
    </div>
  );
}